// extracted by mini-css-extract-plugin
export default {"a":"index-module_a_rslOz","img":"index-module_img_4BTEf"};